import { AudioPlayerStyle } from '~/components/shared/componentStyles/AudioPlayer.style'
import { BetaBadgeStyle } from '~/components/shared/componentStyles/BetaBadge.style'
import { CheckboxStyle } from '~/components/shared/componentStyles/Checkbox.style'
import { CircleBadgeStyle } from '~/components/shared/componentStyles/CircleBadge.style'
import { CustomTooltipStyle } from '~/components/shared/componentStyles/CustomTooltip.style'
import { DropdownStyle } from '~/components/shared/componentStyles/Dropdown.style'
import { DropzoneStyle } from '~/components/shared/componentStyles/Dropzone.style'
import { EmptyDetailViewStyle } from '~/components/shared/componentStyles/EmptyDetailView.style'
import { EmptyStateStyle } from '~/components/shared/componentStyles/EmptyState.style'
import { ExtensionBadgeStyle } from '~/components/shared/componentStyles/ExtensionBadge.style'
import { LoadingSpinnerStyle } from '~/components/shared/componentStyles/LoadingSpinner.style'
import { MangoAlertStyle } from '~/components/shared/componentStyles/MangoAlert.style'
import { MangoButtonStyle } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoCloseButtonStyle } from '~/components/shared/componentStyles/MangoCloseButton.style'
import { MangoModalStyle } from '~/components/shared/componentStyles/MangoModal.style'
import { MenuStyle } from '~/components/shared/componentStyles/Menu.style'
import { MenuItemStyle } from '~/components/shared/componentStyles/MenuItem.style'
import { NewBadgeStyle } from '~/components/shared/componentStyles/NewBadge.style'
import { NotificationBadgeStyle } from '~/components/shared/componentStyles/NotificationBadge.style'
import { PopoverToastStyle } from '~/components/shared/componentStyles/PopoverToast.style'
import { PulsingCircleBadgeStyle } from '~/components/shared/componentStyles/PulsingCircleBadge.style'
import { QuickActionButtonStyle } from '~/components/shared/componentStyles/QuickActionButton.style'
import { ScrollingInputDropdownStyle } from '~/components/shared/componentStyles/ScrollingInputDropdown.style'
import { SearchInputStyle } from '~/components/shared/componentStyles/SearchInput.style'
import { TabButtonStyle } from '~/components/shared/componentStyles/TabButton.style'
import { TagInputStyle } from '~/components/shared/componentStyles/TagInput.style'
import { TextButtonStyle } from '~/components/shared/componentStyles/TextButton.style'

export const sharedComponentStyles = {
  components: {
    AudioPlayerStyle,
    DropdownStyle,
    DropzoneStyle,
    CheckboxStyle,
    CircleBadgeStyle,
    EmptyDetailViewStyle,
    EmptyStateStyle,
    ExtensionBadgeStyle,
    LoadingSpinnerStyle,
    MangoAlertStyle,
    MangoButtonStyle,
    MangoCloseButtonStyle,
    MangoModalStyle,
    PopoverToastStyle,
    PulsingCircleBadgeStyle,
    QuickActionButtonStyle,
    ScrollingInputDropdownStyle,
    SearchInputStyle,
    TabButtonStyle,
    TagInputStyle,
    TextButtonStyle,
    MenuStyle,
    MenuItemStyle,
    NewBadgeStyle,
    BetaBadgeStyle,
    NotificationBadgeStyle,
    CustomTooltipStyle,
  },
}
